export const PointSetType = 'pointSet';
